export * from './parseToThousandsCurrency';
